import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorHighLeverage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M22 7.685C22 6.755 21.25 6 20.325 6H18.6a1.68 1.68 0 0 0-1.675 1.685v12.63c0 .93.75 1.685 1.675 1.685h1.724A1.68 1.68 0 0 0 22 20.315V7.685Zm-1.675-.24a.24.24 0 0 1 .239.24v12.63a.24.24 0 0 1-.24.24h-1.723a.24.24 0 0 1-.24-.24V7.685a.24.24 0 0 1 .24-.24h1.724ZM15.298 13.61c0-.93-.75-1.684-1.676-1.684h-1.628a1.68 1.68 0 0 0-1.675 1.685v6.704c0 .93.75 1.685 1.675 1.685h1.628a1.68 1.68 0 0 0 1.676-1.685V13.61Zm-1.676-.24a.24.24 0 0 1 .24.24v6.705a.24.24 0 0 1-.24.24h-1.628a.24.24 0 0 1-.239-.24V13.61a.24.24 0 0 1 .24-.24h1.627ZM7.207 15.815A1.68 1.68 0 0 1 8.883 17.5v2.815c0 .93-.75 1.685-1.676 1.685H5.676A1.68 1.68 0 0 1 4 20.315V17.5c0-.93.75-1.685 1.676-1.685h1.531Zm.24 1.685a.24.24 0 0 0-.24-.24H5.676a.24.24 0 0 0-.24.24v2.815c0 .133.107.24.24.24h1.531a.24.24 0 0 0 .24-.24V17.5Z"
    />
    <path
      fill="#F7A600"
      d="m14.927 2.478.053.499c.12 1.044-.3 2.357-1.03 3.586a10.867 10.867 0 0 1-3.046 3.287c-.193 1.061-.758 1.878-1.703 2.603l-.82.63-1.148-2.443c-.655-.022-1.294-.416-1.695-.958-.405-.548-.6-1.288-.428-1.942L3.152 5.95l.817-.627c.922-.708 1.843-1.031 2.883-.94a10.527 10.527 0 0 1 3.945-2.085c1.364-.374 2.721-.418 3.672-.013l.458.192Zm-1.288.986c-.583-.14-1.462-.115-2.494.168a9.162 9.162 0 0 0-3.633 1.99l-.242.218-.318-.052a2.4 2.4 0 0 0-1.632.283l1.53 1.397-.374.506c-.082.112-.145.477.149.874.295.4.66.437.775.394l.581-.22.893 1.901c.454-.469.665-.951.727-1.544l.035-.329.273-.18a9.468 9.468 0 0 0 2.88-3.017c.554-.932.82-1.782.85-2.39ZM11.031 6.04a.679.679 0 0 0 .761-.584.679.679 0 0 0-.57-.772.679.679 0 0 0-.762.585.679.679 0 0 0 .57.771ZM2 12.304s1.838-.062 2.612-.668c.587-.46.788-1.22.43-1.716-.359-.494-1.116-.502-1.703-.042C2.645 10.422 2 12.304 2 12.304Z"
    />
  </svg>
);
export default SvgTwoColorHighLeverage;
